import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { getPartners } from '../api/partner.api';
import { partnerKeys } from '../constant/query-keys/partnerKeys';
import { getDataFromResponse } from '../constant/utils/react-query-utils/getDataFromResponse';
import { setPartners } from '../store/slices/partner.slice';
import { setApiError } from '../store/slices/apiError.slice';
import { ErrorSource } from '../constant/model/api/api';
import { handleApiError } from '../constant/utils/error.helper';

export const usePartnersQuery = () => {
  const dispatch = useDispatch();
  
  return useQuery(
    partnerKeys.lists(),
    async () => {
      const response = await getPartners();
      const data = getDataFromResponse(response);
      if (data.statusCode && data.statusCode !== 200) {
        const error = new Error(data.message || 'Request failed') as any;
        error.response = {
          data: data,
          status: data.statusCode,
        };
        throw error;
      } 
      return data;
    },
    {
      onSuccess: (data) => {
        dispatch(setPartners(data.partners));
      },
      onError: (error) => {
        const errorDetails = handleApiError(error);
          dispatch(setApiError({
            source: ErrorSource.PARTNER_LIST,
            error: {
              message: errorDetails.message || 'Failed to fetch partners',
              statusCode: errorDetails.status || 500,
              stack: errorDetails.stack || ''
            }
          }));
      },
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    }
  );
};